export const CollarLeashProductGroupMixins = {
  methods: {
    isCollarGroup(group) {
      return this.getProductTypeByGroup(group ? group : this.getFirstProductGroup()) === 'A';
    },
    isLeashGroup(group) {
      return this.getProductTypeByGroup(group ? group : this.getFirstProductGroup()) === 'S';
    },
    getProductTypeByGroup(group) {
      if (!group) return;
      return group?.productType;
    },
    setProductStyle(style) {
      if (!style) return;
      return this.$store.dispatch(this.isCollarGroup() ? 'collarProduct/setStyle' : 'leashProduct/setStyle', style);
    },
    redirectToStyle({ groupId, productStyle }) {
      if (!groupId || !productStyle) return;
      const query = { ...this.$router.currentRoute.query };
      if (this.redirectPath) {
        query.redirect_path = this.redirectPath;
      }
      this.setProductStyle(productStyle).then(() =>
        this.$router.push({
          name: this.isCollarGroup() ? 'CollarStyle' : 'LeashStyle',
          params: { id: groupId },
          query,
        })
      );
    },
    getFirstProductGroup() {
      return this.groups?.[0] || null;
    },
  },
};
